import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


export class Event{
  target: string; // used as filter condition on subscribe - so that only interested users get notified
  name: string; // target-specific parameter (eg, same listener may support 2 or more different events)
  body: any; // target-specific content/can be anything.

  constructor(target: string, name: string, body?: any) {
    this.target = target;
    this.name = name;
    this.body = body;
  }
}

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {

  constructor() { }

  /**
   * If we need we'll change the Subject into a BehaviourSubject or crate a separate one
   * */
  public eventSubject: Subject<Event> = new Subject();

  /**
   * Listeners of broadcasted events should take care to filter incoming events. Otherwise they will be
   * notified on events they are not supposed to listen. Here is example how the filter should be set up:
   * eventService.events.filter(event => event.eventTarget === 'my_id').subscribe(event => { here goes your usual event listener})
   * @param event
   */
  broadcastEvent(event: Event) {
    this.eventSubject.next(event);
  }
}
